import { Button, Typography } from "@mui/material";
import { theme } from "theme";

export type TCustomGridOptionProps = {
    onClick: () => void;
    marginTop?: string;
    icon: React.ReactElement;
    title: string;
    disabled?: boolean;
};

const CustomGridOption = (props: TCustomGridOptionProps) => {
    return (
        <Button
            onClick={props.disabled ? undefined : props.onClick}
            disableRipple={props.disabled}
            sx={{
                width: '100%',
                bgcolor: props.disabled ? "lightgray" : theme.palette.background.default,
                height: '50px',
                marginTop: props.marginTop ?? "0",
                borderRadius: '10px',
                textTransform: 'none',
                display: 'flex',
                border: `1px solid ${theme.palette.primary.main}`,
                cursor: props.disabled ? 'not-allowed' : 'pointer',
                '&:hover': {
                    bgcolor: props.disabled ? "lightgray" : theme.palette.background.default,
                    cursor: props.disabled ? 'not-allowed' : 'pointer',
                },
            }}>
            {props.icon}
            <Typography sx={{
                color: theme.palette.common.black,
                fontSize: '18px',
                textAlign: 'left',
                paddingLeft: '10px',
                width: '85%'
            }}
            >{props.title}</Typography>
        </Button>
    );
};

export default CustomGridOption;
